<ng-container *ngIf="ValidationUtils.isNonEmptyArray(data.kategorieDoss); else nezvoleno">
  <div *ngFor="let kategorieDoss of data.kategorieDoss" class="mb-5 mt-5">
    <div>{{ kategorieDoss | kategorieDossTooltip }}</div>
  </div>
</ng-container>
<ng-template #nezvoleno>
  <div>nezvoleno</div>
</ng-template>
